<template>
  <div>
    <header-bar></header-bar>
    <div
      class="videomask"
      v-if="videoState == true"
      @click="masksCloseFun"
    ></div>
    <div class="videomasks" v-if="videoState == true">
      <video
        src="https://static4.coolbrainscience.cn/71b8b3b512a74b028743929a7648f835.mp4"
        controls="controls"
        autoplay
        width="100%"
      >
        当前浏览器不支持 video直接播放。
      </video>
    </div>
    <div class="part_1" id="lotus1device">
      <div class="part_1_content">
        <img
          src="https://static4.coolbrainscience.cn/fe8e448981524f1496a590ae3e8fa158.png"
          alt=""
        />
        <div class="part_1_content2">
          <div class="t1">LOTUS 1</div>
          <div class="t2">白天精神好 晚上睡得香</div>
          <div class="t3">&emsp;</div>
          <a href="http://e.tb.cn/h.gE20BU63L3Y36AZ?tk=B3LD3l8nVAx HU9196"
            ><button>经典版</button></a
          >
        </div>
      </div>
    </div>
    <!-- <div class="part_2">
      <div class="t1">使用PanBrain精力舱</div>
      <div class="t1">每天仅需15分钟给大脑做个深度重启</div>
      <div class="t2">平均10次干预后就可以收获显著的</div>
      <div class="effect">
        <div class="effect1">
          <img src="../../assets/icon1.png" />
          <p class="t3">35%</p>
          <p class="t4">水平下降</p>
        </div>
        <div class="effect2">
          <img src="../../assets/icon2.png" />
          <p class="t3">36%</p>
          <p class="t4">压力水平下降</p>
        </div>
        <div class="effect3">
          <img src="../../assets/icon3.png" />
          <p class="t3">34%</p>
          <p class="t4">情绪水平上升</p>
        </div>
        <div class="effect4">
          <img src="../../assets/icon4.png" />
          <p class="t3">38%</p>
          <p class="t4">认知能力上升</p>
        </div>
      </div>
    </div> -->
    <div class="part_3">
      <img src="../../assets/wave.png" />
      <div class="slogan">
        <div class="part_3_t1">随时随地，给大脑充电</div>
        <div class="part_3_t2">
          清晨使用，精力充沛一整天；下午使用，给脑力续航，高效冲刺夜间工作；
        </div>
        <div class="part_3_t2">周末/旅行时使用，唤醒身心平静愉悦的力量。</div>
      </div>
    </div>
    <div class="part_4">
      <div class="title1">你是否有这些困扰？</div>
      <div class="plague">
        <div class="plague_top">
          <div class="plague1">
            <img
              src="https://static4.coolbrainscience.cn/dcb42e3bdc6040568275b7d50123c8ce.png"
            />
            <div class="t">
              <div class="t1">白天精力不足</div>
              <div class="t2">大脑精力浓度不足</div>
            </div>
          </div>
          <div class="plague2">
            <img
              src="https://static4.coolbrainscience.cn/b3c6d9be82084b8db60566a035ad1588.png"
            />
            <div class="t">
              <div class="t1">睡眠质量差</div>
              <div class="t2">大脑休息深度不足</div>
            </div>
          </div>
        </div>
        <div class="plague_bottom">
          <div class="plague1">
            <img
              src="https://static4.coolbrainscience.cn/36f5be9449b24f87b55419affecb9fa8.png"
            />
            <div class="t">
              <div class="t1">工作学习效率低下</div>
              <div class="t2">脑力低</div>
            </div>
          </div>
          <div class="plague2">
            <img
              src="https://static4.coolbrainscience.cn/5a4ae92c516e4528be39545a3f5ba125.png"
            />
            <div class="t">
              <div class="t1">睡醒后精神不振</div>
              <div class="t2">大脑困倦感积累不足额叶兴奋难以入眠</div>
            </div>
          </div>
        </div>
      </div>
      <div class="title2">那是因为你的大脑“共振”失调，脑力进入恶性循环</div>
      <a href="http://e.tb.cn/h.gE20BU63L3Y36AZ?tk=B3LD3l8nVAx HU9196"
        ><button>购买</button></a
      >
    </div>
    <div class="part_5">
      <div class="part_5_left">
        <div class="part_5_left1">
          <img src="../../assets/scenes_icon_recommend.png" class="img7" />
          推荐场景
        </div>
        <div class="part_5_left2">
          清晨起床后出门前使用，利用短短的整理和洗漱时间完成一天的精力提升，还可以快速清醒，同时不影响发型，晚上归家后的休息会更加高效有质量
        </div>
      </div>
      <div class="part_5_right">
        <div class="part_5_right1">
          <img src="../../assets/scenes_icon_superman.png" class="img8" />
          超人模式
        </div>
        <div class="part_5_right2">
          如果想要压缩睡眠时间，可以在下午两点后使用，会使入睡时间延后，但是不影响第二天的起床时间，且第二天不会因睡眠时间缩短而精神不济
        </div>
      </div>
    </div>
    <div class="part_6">
      <div class="part_6_1">
        <div class="part_6_content" style="margin-left: 30%">
          <img src="../../assets/scenes_icon_office.png" class="img9" />
          <div class="part_6_title1">办公室上班</div>
          <div class="part_6_title2">精力充沛</div>
        </div>
      </div>
      <div class="part_6_2">
        <div class="part_6_content">
          <img src="../../assets/scenes_icon_study.png" class="img9" />
          <div class="part_6_title3">居家学习</div>
          <div class="part_6_title4">高效专注</div>
        </div>
      </div>
      <div class="part_6_3">
        <div class="part_6_content">
          <img src="../../assets/scenes_icon_businessTrip.png" class="img9" />
          <div class="part_6_title1">出差</div>
          <div class="part_6_title2">轻巧便携</div>
        </div>
      </div>
      <div class="part_6_4">
        <div class="part_6_content" style="margin-right: 30%">
          <img src="../../assets/scenes_icon_holiday.png" class="img9" />
          <div class="part_6_title3">周末或旅行</div>
          <div class="part_6_title4">充分休息</div>
        </div>
      </div>
    </div>
    <div class="part_7">
      <img @click="checkVideoFun()" src="../../assets/play.png" />
    </div>
    <div class="part_8">
      <div class="part_8_content">
        <div class="t1">智能化穿戴，你的高科技大脑助手</div>
        <div class="t2">
          人体工学的设计，高精度的工艺，领先的自研算法，专业的报告分析
        </div>
      </div>
    </div>
    <div class="part_9">
      <div class="part_9_content">
        <div class="part_9_title1">干预刺激</div>
        <div class="part_9_title2">电极触头+高精度控制电路</div>
        <div class="part_9_title3">
          采用人体工学导电硅胶触头和进口高精度控制电路材料
          ，可以实现非常准确的电流精度。
        </div>
      </div>
    </div>
    <div class="part_10">
      <div class="part_10_content">
        <div class="part_10_title1">脑电检测</div>
        <div class="part_10_title2">金属电极片</div>
      </div>
      <div class="part_10_title3">
        采用核心采集模组配合自研算法技术。通过前额特定区域的脑电波采集，经过特定算法的去噪滤波和脑电频率解析，从而展示出大脑当前的专注状态以及精力程度。
      </div>
    </div>
    <div class="part_11">
      <div class="part_11_content">
        <div class="part_11_title1">智能佩戴检测</div>
        <div class="part_11_title2">智能硬件+自研算法</div>
        <div class="part_11_title3">
          产品自带智能佩戴检测功能，在用户佩戴不佳时，会有语音提示用户校准佩戴。
        </div>
      </div>
    </div>
    <div class="part_12">
      <div class="part_12_content">
        <div class="part_12_title1">人体工学设计</div>
        <div class="part_12_title2">记忆海绵+蛋白皮内衬+可绑带+防滑垫</div>
        <div class="part_12_title3">
          弹性设计，适配多种头围尺寸，贴合人体头部弧度，拥有头部太空舱般的舒适体验，于此同时又能保证佩戴的稳定性。
        </div>
      </div>
    </div>
    <div class="part_13">
      <div class="part_13_content">
        <div class="part_13_title1">高科技超纤材料</div>
        <div class="part_13_title2">超细纤维+智能织法</div>
        <div class="part_13_title3">
          外壳采用高科技超纤维材料，触感轻柔舒适，抗菌耐磨易清洁。
        </div>
      </div>
    </div>
    <div class="part_14">
      <div class="part_14_content">
        <div class="part_14_title1">智能互联掌握大脑变化</div>
        <div class="part_14_title2">蓝牙+应用程序</div>
        <div class="part_14_title3">
          通过产品内置的蓝牙能轻松实现与手机的智能互联，通过手机应用 (般意)
          对产品进行设置和操作，实现产品与消费者的智能互动。并且获取大脑活跃度指标，使用前后状态反馈和个性化用脑建议。
        </div>
      </div>
    </div>
    <div class="part_15">
      <div class="part_15_content">
        <div class="part_15_left">
          <div class="part_15_title1">产品佩戴及使用说明</div>
          <div class="part_15_title2">
            包含内容有首次使用前的注意事项，使用前的注意事项，如何正确佩戴，如何正常使用，用后清洁及保养，如何充电和如何下载APP。
          </div>
          <button type="button" @click="$router.push('/video')">
            立即观看
          </button>
        </div>
        <div class="part_15_right">
          <img
            src="../../assets/Video-Medium.png"
            @click="$router.push('/video')"
          />
        </div>
      </div>
    </div>
    <footer-info></footer-info>
  </div>
</template>
<script>
import footerInfo from "@/components/common/FooterInfo";
import headerBar from "@/components/common/HeaderBar";
export default {
  data() {
    return {
      videoState: false,
    };
  },
  components: {
    footerInfo,
    headerBar,
  },
  created() {
    this.$nextTick(() => {
      this.toLocal();
    });
  },
  methods: {
    checkVideoFun() {
      this.videoState = true;
    },
    masksCloseFun() {
      this.videoState = false;
    },
    toLocal() {
      let Id = window.sessionStorage.getItem("toId");
      if (Id) {
        let toElement = document.getElementById(Id);
        toElement.scrollIntoView();
      }
    },
  },
};
</script>
<style scoped>
.videomask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background-color: #000;
  opacity: 0.6;
}

.videomasks {
  width: 80%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.part_1 {
  width: 100vw;
  height: 56.162vw;
}

.part_1_content img {
  width: 100vw;
  height: 56.162vw;
}

.part_1_content {
  width: 100vw;
  position: absolute;
}

.part_1_content2 {
  width: 100%;
  position: absolute;
  top: 8.75vw;
  text-align: center;
}

.part_1_content2 .t1 {
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_1_content2 .t2 {
  color: #1b1e8a;
  font-size: 3.125vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_1_content2 .t3 {
  color: #333333;
  font-size: 2.5vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_1_content2 button {
  width: 10.52vw;
  height: 2.71vw;
  border-radius: 2.5vw;
  border: none;
  background: linear-gradient(96deg, #888ef9 0%, #fdf6e7 100%);
  color: #ffffff;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
  margin-top: 0.83vw;
}

.part_2 {
  width: 100vw;
  padding: 4vw 0 6vw 0;
  background: #f3f4fe;
  text-align: center;
  position: relative;
}

.part_2 .t1 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.2vw;
  color: #333333;
}

.part_2 .t2 {
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.6vw;
  color: #333333;
  margin: 1.25vw 0;
}

.effect div {
  width: 17.2vw;
  height: 10.4vw;
  background: #e0e0ff;
  display: inline-block;
  margin: 0 0.8vw;
  text-align: center;
}

.effect img {
  width: 4.17vw;
  height: 4.22vw;
  margin-top: 0.6vw;
  margin-bottom: 0.5vw;
}

.effect .t3 {
  color: #333333;
  font-size: 1.7vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  margin: 0;
}

.effect .t4 {
  color: #333333;
  font-size: 0.9vw;
  margin: 0;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_3 {
  width: 100vw;
  height: 20.8vw;
  background: #1b1e8a;
  text-align: center;
  position: relative;
}

.part_3 img {
  width: 73.5vw;
  height: 18.3vw;
  margin-top: 2vw;
}

.slogan {
  text-align: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 13.3vw;
}

.part_3_t1 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  color: #ffffff;
  font-size: 2.5vw;
  margin-bottom: 1.7vw;
}

.part_3_t2 {
  color: #ffffff;
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_4 {
  text-align: center;
  margin-top: 2.08vw;
}

.part_4 .title1 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  color: #333333;
  font-size: 2.5vw;
}

.part_4 .title2 {
  color: #888ef9;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_4 button {
  width: 10.2vw;
  height: 3.125vw;
  margin-top: 4.17vw;
  margin-bottom: 2.08vw;
  border-radius: 0.3125vw;
  border: none;
  color: #ffffff;
  font-size: 0.9375vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  background: #888ef9;
}

.plague {
  font-size: 0;
}

.plague img {
  width: 27.3vw;
  height: 27.3vw;
}

.plague .t {
  position: absolute;
  bottom: 1vw;
  left: 50%;
  transform: translateX(-50%);
}

.plague1,
.plague2 {
  display: inline-block;
  width: 27.3vw;
  height: 27.3vw;
  position: relative;
  margin: 1.5vw 1vw 0.6vw 1vw;
}

.plague .t1 {
  font-size: 1.7vw;
  color: #ffffff;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.plague .t2 {
  font-size: 0.9vw;
  color: #ffffff;
  white-space: nowrap;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_5 {
  background-color: #f3f4fe;
  width: 100vw;
  overflow: hidden;
}

.part_5_left,
.part_5_right {
  float: left;
  width: 40%;
  padding: 4.9vw 0 3.5vw 0;
  text-align: center;
}

.part_5_left {
  margin-left: 10%;
}

.part_5_left1,
.part_5_right1 {
  width: 10.9vw;
  color: #333333;
  font-size: 1.7vw;
  display: inline-block;
  vertical-align: top;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.img7,
.img8 {
  width: 10.9vw;
  height: 10.7vw;
}

.part_5_left2,
.part_5_right2 {
  width: 50%;
  color: #333333;
  font-size: 0.9vw;
  margin-left: 2vw;
  text-align: justify;
  display: inline-block;
  margin-top: 1.6vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_6 {
  margin-top: 1.25vw;
  width: 100vw;
  text-align: center;
  font-size: 0;
}

.part_6_1 {
  width: 30%;
  background-color: #888ef9;
  position: relative;
  display: inline-block;
}

.part_6_content {
  padding: 3.1vw 0 3.3vw 0;
}

.part_6_2 {
  width: 20%;
  background-color: #f3f4fe;
  display: inline-block;
}

.part_6_3 {
  width: 20%;
  background-color: #888ef9;
  display: inline-block;
}

.part_6_4 {
  width: 30%;
  background-color: #f3f4fe;
  display: inline-block;
}

.img9 {
  width: 7.8vw;
  height: 7.8vw;
}

.part_6_title1 {
  font-size: 1.7vw;
  color: #ffffff;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  margin-top: 1.9vw;
}

.part_6_title2 {
  color: #ffffff;
  font-size: 0.9vw;
  margin-top: 0.8vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_6_title3 {
  font-size: 1.7vw;
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  margin-top: 1.9vw;
}

.part_6_title4 {
  color: #333333;
  font-size: 0.9vw;
  margin-top: 0.8vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_7 {
  width: 100vw;
  height: 56.25vw;
  background: url(../../assets/1.png) no-repeat;
  /* background: url(https://static4.coolbrainscience.cn/0ca198948b1e48248af5179be10b2641.png); */
  background-size: 100% 100%;
  text-align: center;
  line-height: 56.25vw;
}

.part_7 img {
  width: 5.2vw;
  height: 5.2vw;
  vertical-align: middle;
}

.part_8 {
  width: 100vw;
  height: 11.9vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #888ef9;
  text-align: center;
}

.part_8_content .t1 {
  font-size: 2.2vw;
  color: #ffffff;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_8_content .t2 {
  font-size: 0.9vw;
  color: #ffffff;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  margin-top: 0.6vw;
}

.part_9_title1,
.part_10_title1,
.part_11_title1,
.part_12_title1,
.part_13_title1,
.part_14_title1 {
  font-size: 2.19vw;
  color: #333333;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_9_title2,
.part_10_title2,
.part_11_title2,
.part_12_title2,
.part_13_title2,
.part_14_title2 {
  color: #9b9b9b;
  font-size: 1.67vw;
  margin-top: 1.56vw;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
}

.part_9_title3,
.part_11_title3,
.part_12_title3,
.part_13_title3,
.part_14_title3 {
  margin-top: 0.83vw;
  font-size: 0.9vw;
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_9,
.part_10,
.part_11,
.part_12,
.part_13,
.part_14 {
  width: 100vw;
  height: 31.25vw;
  position: relative;
}

.part_9 {
  background: url(../../assets/3.png) no-repeat;
  background-size: 100% 100%;
}

.part_10 {
  background: url(../../assets/4.png) no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

.part_11 {
  background: url(../../assets/5.png) no-repeat;
  background-size: 100% 100%;
}

.part_12 {
  background: url(../../assets/6.png) no-repeat;
  background-size: 100% 100%;
}

.part_13 {
  background: url(../../assets/7.png) no-repeat;
  background-size: 100% 100%;
}

.part_14 {
  background: url(../../assets/8.png) no-repeat;
  background-size: 100% 100%;
}

.part_9_content,
.part_14_content {
  width: 28.6vw;
  position: absolute;
  top: 6.56vw;
  right: 11vw;
}

.part_12_content {
  position: absolute;
  top: 6.56vw;
  right: 11vw;
  width: 31.25vw;
}

.part_10_content {
  float: left;
  margin-top: 4.84vw;
  margin-left: 13vw;
}

.part_11_content,
.part_13_content {
  position: absolute;
  top: 8.59vw;
  left: 13vw;
  width: 28.6vw;
}

.part_10_title3 {
  width: 55.7vw;
  font-size: 0.9vw;
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  float: left;
  margin-top: 5.57vw;
  margin-left: 4vw;
}

.part_15 {
  width: 100vw;
  height: 39vw;
  background: #f3f4fe;
}

.part_15_content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
}

.part_15_left {
  width: 28vw;
  position: absolute;
  left: 13.02vw;
}

.part_15_title1 {
  color: #333333;
  font-size: 2.2vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  margin-bottom: 1.56vw;
}

.part_15_title2 {
  font-size: 0.9vw;
  color: #9b9b9b;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  margin-bottom: 2.92vw;
}

.part_15_left button {
  width: 10vw;
  height: 3vw;
  background: #888ef9;
  border-radius: 0.3vw;
  color: #ffffff;
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  border: none;
}

.part_15_right {
  width: 36.46vw;
  height: 23.96vw;
  position: absolute;
  right: 13.02vw;
}

.part_15_right img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Lotus1device.vue